import { Injectable } from '@angular/core';
import { UserModel } from 'src/app/account/core/models/user.model';
import { AuthService } from 'src/app/account/core/services/auth.service';
import { PERMISSION } from '../constants/permissions-constants';

@Injectable({ providedIn: 'root' })
export class PermissionService {

  private user: UserModel;

  constructor(
    private authenticationService: AuthService,
    ) {
    this.authenticationService.currentUser$.subscribe(user => {
      this.user = user;
    })
  }

  hasPermission(permission: string): boolean {
    if (!this.user || !permission || permission.trim().length === 0) {
      return false;
    }

    return this.user.permissions.includes(permission);
  }

  hasUserRequiredPermissionToUseApp(): boolean {
    if (!this.user?.permissions) {
      return false;
    }
    if (this.user && this.user.permissions.length == 0) return false;
    const requiredPermissions = [
      'Pages.Tenant.Dashboard',
      'Pages.LiveView',
      'Pages.Incidents',
      'Pages.IncidentsReports',
      'Pages.Site.SiteMaps',
      'Pages.CameraHealth',
      'Pages.Administration.Users',
      'Pages.Administration.Roles',
      'Pages.Administration.PropertyGroups'
    ];
    let hasRequiredPermissions = this.user.permissions.some((permission) =>
      requiredPermissions.includes(permission)
    );
    return hasRequiredPermissions;
  }

  hasDashboardPermission(): boolean {
    if (!this.user?.permissions) {
      return false;
    }
  
    const hasDashboard = this.user.permissions.includes(PERMISSION.Pages_Tenant_Dashboard);
    const hasLiveView = this.user.permissions.includes(PERMISSION.Pages_LiveView);
    const hasIncidents = this.user.permissions.includes(PERMISSION.Pages_Incidents);
    const hasIncidentsReports = this.user.permissions.includes(PERMISSION.Pages_IncidentReports);
  
    if (hasDashboard && !hasLiveView && !hasIncidents && !hasIncidentsReports) {
      return false;
    }
  
    if (hasDashboard && (hasLiveView || hasIncidents || hasIncidentsReports)) {
      return true;
    }
  
    return false;
  }
  

  isTenantAdmin(): boolean {
    if (!this.user) return false;
    return this.user.isTenantAdmin;
  }
}
